import { curry } from 'lodash';

export default {
    props: {
        selectedColName: {
            type: String,
            required: true
        },
        cellInfo: {
            type: Object,
            required: true
        },
        gridBoundary: {
            type: DOMRect,
            required: true
        }
    },
    created() {
        this.onDrop = curry(this.onDrop);
    },
    methods: {
        onDrop(direction, e) {
            e.stopPropagation();

            this.$emit("onDrop", {
                direction,
                cellInfo: this.cellInfo
            });
        },
        onDragover(e) {
            e.preventDefault();
        },
        onMousedown(e) {
            e.preventDefault();
        },
        onDragstart(e) {
            this.$emit("onDrag", {
                cellInfo: this.cellInfo
            });
        }
    },
    render(h) {

        const children = ['top', 'right', 'bottom', 'left'].map(item => <div
            class={`mask-item-${item}`}
            onMousedown={this.onMousedown}
            onDragover={this.onDragover}
            onDrop={this.onDrop(item)}
        ></div>)

        return (
            <div
                class={[
                    'mask-item',
                    this.selectedColName === this.cellInfo.ColName
                        ? 'active'
                        : ''
                ]}
                data-col-name={this.cellInfo.ColName}
                draggable
                onDragstart={this.onDragstart}
                style={{
                    left: `${this.cellInfo.Boundary.left -
                        this.gridBoundary.left}px`,
                    top: `${this.cellInfo.Boundary.top -
                        this.gridBoundary.top}px`,
                    width: `${this.cellInfo.Boundary.width}px`,
                    height: `${this.cellInfo.Boundary.height}px`
                }}
                onDragover={this.onDragover}
                onDrop={this.onDrop('inner')}
            >
                {children}
            </div>
        );
    }
};
